import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_custom_select_field = _resolveComponent("custom-select-field")

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass($props.classes)
      }, [
        _createVNode(_component_custom_select_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
          small: $props.small,
          placeholder: $options.dynamicPlaceholderText,
          "data-qa": `filtersbox-field:${_ctx.displayName}`
        }), {
          description: _withCtx(() => [
            _renderSlot(_ctx.$slots, "description")
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.normalizedOptions, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'multi-select-filter-item-' + option.value
              }, [
                _createVNode(_component_checkbox_field, {
                  "model-value": _ctx.modelValue,
                  "display-name": option.name,
                  "checked-value": option.value,
                  inline: true,
                  condensed: true,
                  "onUpdate:modelValue": $options.onInput,
                  "data-qa": `multiselect-filter-checkbox:${option.name}`
                }, null, 8 /* PROPS */, ["model-value", "display-name", "checked-value", "onUpdate:modelValue", "data-qa"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 3 /* FORWARDED */
        }, 16 /* FULL_PROPS */, ["small", "placeholder", "data-qa"])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}